/* TwoMemo header — mobile drawer + current-page marking.
   The drawer/scrim render OUTSIDE the .tmh header (backdrop-filter would
   otherwise clamp a fixed child to the header height), so they are looked up
   from the document, and open/close is driven by a `tmh-open` class on <html>
   (which also locks page scroll). */
(function () {
  var root = document.documentElement;

  function init(h) {
    if (h.dataset.tmhBound) return;
    h.dataset.tmhBound = '1';

    var drawer = document.querySelector('[data-tmh-drawer]');
    var scrim = document.querySelector('[data-tmh-scrim]');
    var openBtn = h.querySelector('[data-tmh-open]');
    var closeBtn = drawer && drawer.querySelector('[data-tmh-close]');

    function isOpen() { return root.classList.contains('tmh-open'); }
    function open() {
      if (!drawer) return;
      root.classList.add('tmh-open');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
      var first = drawer.querySelector('a, button');
      if (first) first.focus();
    }
    function close() {
      root.classList.remove('tmh-open');
      if (openBtn) { openBtn.setAttribute('aria-expanded', 'false'); openBtn.focus(); }
    }
    if (openBtn) openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (scrim) scrim.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) close();
    });

    // Collapsible sub-groups (Couple sets / Single tees).
    if (drawer) drawer.querySelectorAll('[data-tmh-acc]').forEach(function (btn) {
      var sub = document.getElementById(btn.getAttribute('aria-controls'));
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        if (sub) sub.hidden = expanded;
      });
    });

    // Mark the current top-level item (SPEC: 2px ink underline).
    var path = window.location.pathname;
    h.querySelectorAll('.tmh__top').forEach(function (a) {
      var href = (a.getAttribute('href') || '').split('?')[0];
      if (href && href !== '/' && path.indexOf(href) === 0) a.setAttribute('aria-current', 'page');
    });

    // Keep the cart count in sync: after AJAX cart updates (header + drawer), and when the page is
    // restored from the back/forward cache (otherwise the count would be stale after adding to cart).
    var last = null;
    function paint(count) {
      document.querySelectorAll('[data-tmh-count]').forEach(function (n) {
        n.textContent = count;
        n.classList.toggle('is-empty', count === 0 && n.closest('[data-tmh-bag]'));
        if (last !== null && count > last && n.closest('[data-tmh-bag]')) { n.classList.remove('is-bump'); void n.offsetWidth; n.classList.add('is-bump'); }
      });
      var bag = h.querySelector('[data-tmh-bag]');
      if (bag) bag.setAttribute('aria-label', 'Cart, ' + count + (count === 1 ? ' item' : ' items'));
      var live = h.querySelector('[data-tmh-live]');
      if (live && last !== null && count !== last) live.textContent = 'Cart updated: ' + count + (count === 1 ? ' item' : ' items');
      last = count;
    }
    function refresh() {
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (c) { paint(c.item_count); })
        .catch(function () {});
    }
    var first = h.querySelector('[data-tmh-count]');
    if (first) last = parseInt(first.textContent, 10) || 0;
    ['cart:updated', 'cart:change', 'cart:refresh', 'product:added'].forEach(function (ev) { document.addEventListener(ev, refresh); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
    window.TMRefreshCart = refresh;
  }

  function boot() { document.querySelectorAll('[data-tmh]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
